import * as React from 'react';
import './inputs-generator.scss';

interface InputsGeneratorProps {
  count: number;
  variant?: 'standard' | 'outlined' | 'filled';
  placeholder: string;
  onChange: (index: number, value: string) => void;
  values: string[];
  errors?: (string | null)[];
  onBlur?: (index: number, e: any) => void;
  showHelperText?: boolean;
}

export const InputsGenerator: React.FC<InputsGeneratorProps> = ({
  count,
  placeholder = 'Source',
  onChange,
  values,
  errors = [],
  onBlur,
  showHelperText = true,
}) => {
  return (
    <div className="InputsGenerator__Stack">
      {Array.from({ length: count }, (_, i) => {
        const err = errors[i] ?? null;
        return (
          <div key={i} className="InputsGenerator__Item">
            <input
              className={`InputsGenerator__Input SOURCE__INPUT ${err ? 'error' : ''}`}
              type="url"
              placeholder={`${placeholder} #${i + 1}`}
              aria-label={`Source ${i + 1}`}
              id={`source-input-${i + 1}`}
              maxLength={2048}
              inputMode="url"
              onChange={(e) => onChange(i, e.target.value)}
              value={values[i] ?? ''}
              onBlur={(e) => onBlur?.(i, e)}
            />
            {showHelperText && err && (
              <p className="InputsGenerator__Error">{err}</p>
            )}
          </div>
        );
      })}
    </div>
  );
};
